import React, { useEffect, useState } from "react";
import {
    Box,
    Flex,
    Avatar,
    Text,
    Tag,
    Button,
    VStack,
    HStack,
    Stack,
    Heading,
    Divider,
    Spinner,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
} from "@chakra-ui/react";
import { getExpertDetailProfile } from "../../actions/user/userActions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

function ExpertProfile() {
    const dispatch = useDispatch();
     const { expertId } = useParams();

    const { data: rawData, loading, message: errorMessage } = useSelector(
        (state) => state.expertDetailProfileReducer || {}
    );
    // Ensure data is always an array (fallback empty array)
    const data = Array.isArray(rawData) ? rawData : [];

    const [selectedExpert, setSelectedExpert] = useState(null);
    const initialIndex = data.findIndex((expert) => expert._id === expertId);

    useEffect(() => {
        dispatch(getExpertDetailProfile(expertId));
        console.log("Dispatched getExpertDetailProfile");
    }, [dispatch,expertId]);

    useEffect(() => {
        console.log("Redux data updated:", rawData);
    }, [rawData]);

    useEffect(() => {
    if (data.length > 0) {
        const selected = data.find((expert) => expert._id === expertId);
        setSelectedExpert(selected || data[0]);
    }
}, [data, expertId]);


    console.log("Fetched expert data:", data);

    if (loading) {
        return (
            <Flex justify="center" align="center" h="100vh">
                <Spinner size="xl" />
            </Flex>
        );
    }



    if (data.length === 0) {
        return (
            <Flex justify="center" align="center" h="100vh">
                <Text>No expert data available</Text>
            </Flex>
        );
    }

    const handleTabChange = (index) => {
        setSelectedExpert(data[index]);
    };

    return (
        <Flex minH="150vh" p={10} direction="column" align="center">
            <Heading size="sm" mb={6} alignSelf="flex-start">
                EXPERT PROFILE
            </Heading>

           

<Tabs
    variant="enclosed"
    isFitted
    w="100%"
    maxW="1200px"
    index={initialIndex !== -1 ? initialIndex : 0}
    onChange={handleTabChange}
>

                <TabList>
                    {data.map((expert) => (
                        <Tab key={expert._id}>{expert.expert_name}</Tab>
                    ))}
                </TabList>

                <TabPanels>
                    {data.map((expert) => (
                        <TabPanel key={expert._id} p={0} pt={6}>
                            {selectedExpert && (
                                <Flex
                                    w="100%"
                                    maxW="1100px"
                                    bg="white"
                                    boxShadow="lg"
                                    borderRadius="lg"
                                    p={6}
                                    direction={{ base: "column", lg: "row" }}
                                >
                                    {/* Left Panel */}
                                    <Box
                                        flex="2"
                                        pr={{ lg: 6 }}
                                        borderRight={{ lg: "1px solid #e2e8f0" }}
                                    >
                                        <Flex justify="space-between" flexWrap="wrap" mb={6}>
                                            <HStack spacing={6} align="start">
                                                <Avatar
                                                    size="xl"
                                                    name={selectedExpert.expert_name}
                                                    src={selectedExpert.profile_image}  // Use profile_image from API here
                                                />

                                                <VStack align="start" spacing={1}>
                                                    <Text fontWeight="bold" fontSize="xl">
                                                        {selectedExpert.expert_name}
                                                    </Text>
                                                    <Text>{selectedExpert.expert_title}</Text>


                                                </VStack>
                                            </HStack>
                                        </Flex>

                                        <Divider mb={6} />

                                        <Heading size="sm" mb={4} color="#b9b5b5">
                                            Expertise in industries
                                        </Heading>

                                        <Flex gap={4} flexWrap="wrap" justify="space-between">
                                            {Array.isArray(selectedExpert.sectors) &&
                                                selectedExpert.sectors.map((sector, index) => (
                                                    <Box
                                                        key={index}
                                                        p={4}
                                                        borderWidth="1px"
                                                        borderRadius="md"
                                                        flexBasis={{ base: "100%", md: "48%" }}
                                                    >
                                                        {/* Sector Tag */}
                                                        <HStack spacing={2} mt={1}>
                                                            <Text fontWeight="semibold" color="#1E1E1E">{sector}</Text>

                                                        </HStack>



                                                        {/* Action Taken (all items combined with commas) */}
                                                        <Text mt={2} fontWeight="semibold" size="sm">
                                                            Action Taken
                                                        </Text>

                                                        <Text>
                                                            {selectedExpert.actions_taken
                                                                ?.map((action) => action.title)
                                                                .filter(Boolean)
                                                                .join(", ")}
                                                        </Text>



                                                        {/* Results */}
                                                        <Heading size="sm" mb={2}>
                                                            Results
                                                        </Heading>
                                                        <VStack align="start" spacing={2}>
                                                            {Array.isArray(selectedExpert.results) &&
                                                                selectedExpert.results.map((result, i) => (
                                                                    <Text key={i}> {result}</Text>
                                                                ))}
                                                        </VStack>
                                                    </Box>
                                                ))}
                                        </Flex>


                                        <Divider my={6} />

                                        {/* Results */}

                                    </Box>

                                    {/* Right Panel */}
                                    <Box flex="1" pl={{ lg: 6 }} mt={{ base: 6, lg: 0 }}>
                                        <Heading size="sm" mb={4}>
                                            SERVICE DELIVERY STEPS
                                        </Heading>
                                        <Stack spacing={6}>
                                            {[
                                                {
                                                    title: "Resource Allocation",
                                                    duration: "1 week approx.",
                                                    infoNeeded: [
                                                        "Project Plan",
                                                        "Budget",
                                                        "Resource Availability Report",
                                                    ],
                                                    steps: ["01", "02", "03", "04", "05"],
                                                },
                                                {
                                                    title: "Risk Management",
                                                    duration: "2 weeks approx.",
                                                    infoNeeded: [
                                                        "Stakeholder Analysis",
                                                        "SWOT Analysis",
                                                        "Contingency Plan",
                                                        "Risk Management Plan",
                                                    ],
                                                    steps: ["01", "02", "03", "04", "05"],
                                                },
                                            ].map((service, idx) => (
                                                <Box key={idx} p={4} borderWidth="1px" borderRadius="md">
                                                    <Flex
                                                        justify="space-between"
                                                        align="center"
                                                        mb={2}
                                                    >
                                                        <Text fontWeight="bold">{service.title}</Text>
                                                        <Button size="sm" colorScheme="gray">
                                                            Enquire
                                                        </Button>
                                                    </Flex>
                                                    <Text fontSize="sm" mb={2}>
                                                        {service.duration}
                                                    </Text>
                                                    <Text fontWeight="semibold" mb={2}>
                                                        Information Needed
                                                    </Text>
                                                    <HStack spacing={2} wrap="wrap" mb={3}>
                                                        {service.infoNeeded.map((item, i) => (
                                                            <Tag
                                                                key={i}
                                                                variant="subtle"
                                                                colorScheme="gray"
                                                            >
                                                                {item}
                                                            </Tag>
                                                        ))}
                                                    </HStack>
                                                    <Text fontWeight="semibold">Steps</Text>
                                                    <HStack spacing={2} mt={2}>
                                                        {service.steps.map((step, i) => (
                                                            <Box
                                                                key={i}
                                                                w={6}
                                                                h={6}
                                                                bg="gray.100"
                                                                borderRadius="full"
                                                                textAlign="center"
                                                                lineHeight="6"
                                                                fontSize="sm"
                                                                fontWeight="medium"
                                                            >
                                                                {step}
                                                            </Box>
                                                        ))}
                                                    </HStack>
                                                </Box>
                                            ))}
                                        </Stack>
                                    </Box>
                                </Flex>
                            )}
                        </TabPanel>
                    ))}
                </TabPanels>
            </Tabs>
        </Flex>
    );
}

export default ExpertProfile;
